module.exports = __webpack_public_path__ + "img/bg3.53d4d87a.jpg";